


import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class ApplicationNotesModal extends Vue {
  public loading: boolean = false;

  public showConfirm(): void {
    this.$info({
      class: 'application-notes',
      title: '各位考生：欢迎报考人大附中通州校区中美合作“国际高中课程项目”。',
      content: (h: any) => {
        const t1 = h('h3', '报名须知');
        const p1 = h('p', '1、项目招生对象：根据北京市关于中外合作办学项目的政策，符合相关规定并具备报名资格的学生均可报名参加；');
        const p2 = h(
          'p',
          '   2、项目报名形式：本系统仅进行信息登记 ，有意愿参加我校中美高中课程合作项目招生的学生，皆必须在中考结束后，持在本系统报名成功后打印的现场确认单、中考准考证、中考成绩单来我校进行现场确认（具体时间请关注我校官网通知）',
        );
        const p3 = h('p', '人大附中通州校区严格遵守市区教委和上级部门关于中外合作项目招生的相关规定和政策。');
        const t2 = h('h3', '报名流程');
        const p4 = h('p', '第一步：认真阅读招生简章和报名须知。');
        const p5 = h(
          'p',
          '第二步：新用户报名：所有欲申请我校中美高中课程合作项目的学生请先进行新用户报名，报名时请认真核对所填信息后再行提交。考生也可以用报名时自己设置的手机号登录系统，进行信息查看、补充、修改和打印等操作。',
        );
        const p6 = h('p', '  第三步：修改报名表：在提交了申请表之后，考生可以登录系统，点击【补全成绩】，通过此功能对申请表格进行修改和完善。');
        const p7 = h(
          'p',
          '第四步：现场确认：所有需要参加我校中美高中课程合作项目招生的学生，在中考结束后还须持本系统的报名成功后打印的现场确认单、中考成绩单、中考准考证来我校进行现场确认（具体时间请关注我校官网通知）',
        );
        const t3 = h('h3', '注意事项');
        const p8 = h('p', '1.首次登录，我们将手机号自动注册为您的账号；同一家庭申请多个小孩，登录/注册务必使用同一个手机号码。');
        const p9 = h('p', '2.在新用户报名时，报名信息录入要准确真实。提交之后如发现信息录入错误或需补充相关信息，可以重新登录进行修改。');
        const p10 = h('p', '3.考生姓名栏所填姓名，应与本人身份证、户口本的姓名一致。');
        const p11 = h('p', '4.报名后请大家记住网络报名时所用手机号，以备今后在系统中进行结果查询。');
        const p12 = h('p', '5.网络环境差的情况下，请用户随时保存草稿；推荐使用谷歌浏览器，暂不支持IE浏览器。');
        const p13 = h('p', '6.未尽事宜，以市区教委和上级部门的文件为准。');
        return h('div', [t1, p1, p2, p3, t2, p4, p5, p6, p7, t3, p8, p9, p10, p11, p12, p13]);
      },
      width: 800,
      okButtonProps: { loading: true, size: 'large' } as any,
      centered: true,
      onOk: () => {
        // OK
        this.loading = true;
        localStorage.setItem('tip', 'true');
        this.$emit('ok', () => {
          this.loading = false;
        });
      },
    });
  }
}
